<template>
  <Teleport to=".app-root">
    <div
      class="fixed inset-x-0 top-0 bottom-(--mobile-nav-height) z-(--z-modal) overflow-hidden"
      :class="!modelValue && 'pointer-events-none'"
      :inert="!modelValue"
    >
      <div
        class="absolute inset-0 bg-backdrop transition-opacity duration-200"
        :class="!modelValue && 'opacity-0'"
        @click="emit('update:modelValue', false)"
      ></div>
      <div
        class="absolute inset-x-0 bottom-0 rounded-t-[1.25rem] border-t border-line bg-bg2 px-2 pt-2 pb-2
               transition-[translate] duration-200 ease-out"
        :class="!modelValue && 'translate-y-full'"
        @transitionend.self="!modelValue && emit('closed')"
      >
        <slot></slot>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue', 'closed']);
</script>
